module.exports = __webpack_public_path__ + "static/media/withdrawal_qiwi_pressed.8d9e8c7d.svg";